/* eslint-disable */
import { Actions, ActionsTypes } from '../actions/actions';

export interface State {
  isLoading: boolean;
  data: string[];
}

function getInitialState(): State {
  return {
    isLoading: true,
    data: []
  };
}

const initialState: State = getInitialState();

export function reducer(state = initialState, action: Actions): State {
  switch (action.type) {
    case ActionsTypes.SetupPermissionsSuccess: {
      return { ...state, isLoading: false, data: action.payload.permissions };
    }

    default:
      return state;
  }
}
